export const iconFontAwesomeAutomotiveVanShuttle = (
	<i className="fa-solid fa-van-shuttle"></i>
);
